import { useState, type FormEvent } from 'react';

export type FormStatus = 'idle' | 'loading' | 'success' | 'error';

export function useFormSubmit(url: string) {
  const [status, setStatus] = useState<FormStatus>('idle');
  const [error, setError] = useState('');

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('website_alt') || '').trim();
    if (honeypot) {
      setStatus('success');
      form.reset();
      return;
    }
    formData.delete('website_alt');

    setStatus('loading');
    setError('');

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, String(value));
    });

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = String(serverMsg).toLowerCase().includes('spam');

      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setError('网络异常，请检查网络后重试');
    }
  };

  const reset = () => {
    setStatus('idle');
    setError('');
  };

  return { status, error, submit, reset };
}